module.exports = __webpack_public_path__ + "static/media/rps.f7be8971.png";